import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createSubscription, editSubscription, getSubscriptionById, subscriptionDelete, subscriptionList, updateSubscriptionStatus } from "../../services/api";
import { secretKey } from "../../services/config";
import EncryptDecrypt from "../../utils/encrypt&decrypt";

const namespace = "subscription";

// Async thunk for fetching the subscription list
export const getSubscriptionList = createAsyncThunk(
    `${namespace}/getSubscriptionList`,
    async (
        { query = "", page = 1, limit = 10, sortby = "", order = "" },
        { rejectWithValue }
    ) => {
        try {
            const data = await subscriptionList(query, page, limit, sortby, order);
            return JSON.parse(EncryptDecrypt.decryptdata(data.data.datas, secretKey));
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Async thunk for adding a subscription
export const addSubscription = createAsyncThunk(
    `${namespace}/subscription`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            let payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await createSubscription({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Async thunk for fetching subscription data by ID
export const getSubscriptionData = createAsyncThunk(
    `${namespace}/getSubscriptionData`,
    async ({ id }, { rejectWithValue }) => {
        try {
            const data = await getSubscriptionById(id);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Async thunk for updating subscription data
export const updateSubscription = createAsyncThunk(
    `${namespace}/updateSubscription`,
    async ({ postData, updateID }, { rejectWithValue }) => {
        try {
            let payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await editSubscription({ payload }, updateID);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const subscriptionStatus = createAsyncThunk(
    `${namespace}/subscriptionStatus`,
    async ({ postData, updateID }, { rejectWithValue }) => {
        try {
            let payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await updateSubscriptionStatus({ payload }, updateID);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const deleteSubscription = createAsyncThunk(
    `${namespace}/deleteSubscription`,
    async ({ deleteID }, { rejectWithValue, dispatch }) => {
        try {
            console.log(deleteID, "interdata");
            const data = await subscriptionDelete(deleteID);
            console.log("getCount--> ", data);
            return data;
        } catch (error) {
            console.log("getCount error--->", error);
            return rejectWithValue(error.response);
        }
    }
);


const subscriptionSlice = createSlice({
    name: namespace,
    initialState: {
        subscriptionListData: [],
        subscriptionListLoading: false,
        addSubscriptionLoading: false,
        addSubscriptionSuccess: false,
        subscriptionErrorMessages: null,
        addedSubscription: null,
        getAddedData: [],
        updateData: [],
        updateSubscriptionSuccess: false,
        deleteSubscriptionLoading: false,
        deleteSubscriptionSuccess: false,
        deleteSubscriptionError: false,
        deleteSubscriptionErrorMessage: "",
        subscriptionStatusLoading: false,
        subscriptionStatusSuccess: false,
        subscriptionStatusError: false,
        subscriptionStatusErrorMessage: "",
    },
    reducers: {
        resetSuccessFlag: (state, action) => {
            const { flag } = action.payload;
            state[flag] = false;
        },
    },
    extraReducers: (builder) => {
        builder
            // Handle getSubscriptionList
            .addCase(getSubscriptionList.pending, (state) => {
                state.subscriptionListLoading = true;
                state.addSubscriptionLoading = false;
                state.addSubscriptionSuccess = false;
                state.subscriptionErrorMessages = null;
                state.addedSubscription = null;
                state.getAddedData = [];
                state.updateData = [];
                state.updateSubscriptionSuccess = false;
                state.deleteSubscriptionLoading = false;
                state.deleteSubscriptionSuccess = false;
                state.deleteSubscriptionError = false;
                state.deleteSubscriptionErrorMessage = "";
                state.subscriptionStatusLoading = false;
                state.subscriptionStatusSuccess = false;
                state.subscriptionStatusError = false;
                state.subscriptionStatusErrorMessage = "";
            })
            .addCase(getSubscriptionList.fulfilled, (state, action) => {
                const data = action.payload;
                state.subscriptionListData = data;
                state.subscriptionListLoading = false;
                state.subscriptionErrorMessages = '';
            })
            .addCase(getSubscriptionList.rejected, (state,action) => {
                state.subscriptionListLoading = false;
                // state.subscriptionErrorMessages = action?.payload?.data?.errors[0]?.message;
                state.subscriptionErrorMessages = action.payload.data.message;
            })

            // Handle addSubscription
            .addCase(addSubscription.pending, (state) => {
                state.addSubscriptionLoading = true;
                state.subscriptionErrorMessages = null;
                state.addedSubscription = null;
                state.addSubscriptionSuccess = false;
            })
            .addCase(addSubscription.fulfilled, (state, action) => {
                state.addSubscriptionLoading = false;
                state.addedSubscription = action.payload;
                state.addSubscriptionSuccess = true;
                state.subscriptionErrorMessages = '';
            })
            .addCase(addSubscription.rejected, (state, action) => {
                console.log(action,'action');
                state.addSubscriptionLoading = false;
                // state.subscriptionErrorMessages = action?.payload?.data?.errors[0]?.message;
                state.subscriptionErrorMessages = action.payload.data.message;
                state.addSubscriptionSuccess = false;
            })

            // Handle getSubscriptionData by ID
            .addCase(getSubscriptionData.pending, (state) => { })
            .addCase(getSubscriptionData.fulfilled, (state, action) => {
                const data = JSON.parse(EncryptDecrypt.decryptdata(action.payload.data.datas, secretKey));
                state.getAddedData = data.response;
                state.subscriptionErrorMessages = '';
            })
            .addCase(getSubscriptionData.rejected, (state,action) => {
                // state.subscriptionErrorMessages = action?.payload?.data?.errors[0]?.message;
                state.subscriptionErrorMessages = action.payload.data.message;

             })

            // Handle updateSubscription
            .addCase(updateSubscription.pending, (state) => {
                state.updateSubscriptionSuccess = false;
            })
            .addCase(updateSubscription.fulfilled, (state, action) => {
                state.updateData = action.payload;
                state.updateSubscriptionSuccess = true;
                state.subscriptionErrorMessages = '';
            })
            .addCase(updateSubscription.rejected, (state,action) => {
                state.updateSubscriptionSuccess = false;
                // state.subscriptionErrorMessages = action?.payload?.data?.errors[0]?.message;
                state.subscriptionErrorMessages = action.payload.data.message;
            })

            // Update subscription status
            .addCase(subscriptionStatus.pending, state => {
                state.subscriptionStatusLoading = true;
                state.subscriptionStatusSuccess = false;
                state.subscriptionStatusError = false;
                state.subscriptionStatusErrorMessage = "";
                state.deleteSubscriptionLoading = false;
                state.deleteSubscriptionError = false;
                state.deleteSubscriptionSuccess = false;
                state.deleteSubscriptionErrorMessage = "";
            })
            .addCase(subscriptionStatus.fulfilled, (state, action) => {
                state.subscriptionStatusSuccess = true;
                state.subscriptionStatusLoading = false;
                state.subscriptionErrorMessages = '';
            })
            .addCase(subscriptionStatus.rejected, (state, action) => {
                state.subscriptionStatusError = true;
                state.subscriptionStatusLoading = false;
                // state.subscriptionErrorMessages = action?.payload?.data?.errors[0]?.message;
                state.subscriptionErrorMessages = action.payload.data.message;

            })

            // Handle DeleteSubscription
            .addCase(deleteSubscription.pending, state => {
                state.deleteSubscriptionLoading = true;
                state.deleteSubscriptionError = false;
                state.deleteSubscriptionSuccess = false;
                state.deleteSubscriptionErrorMessage = "";
                state.subscriptionStatusLoading = false;
                state.subscriptionStatusSuccess = false;
                state.subscriptionStatusError = false;
                state.subscriptionStatusErrorMessage = "";
            })
            .addCase(deleteSubscription.fulfilled, (state, action) => {
                state.deleteSubscriptionSuccess = true;
                state.deleteSubscriptionLoading = false;
                state.subscriptionErrorMessages = '';
            })
            .addCase(deleteSubscription.rejected, (state, action) => {
                state.deleteSubscriptionError = true;
                state.deleteSubscriptionLoading = false;
                // state.subscriptionErrorMessages = action?.payload?.data?.errors[0]?.message;
                state.subscriptionErrorMessages = action.payload.data.message;

            })
    },
});

export const { resetSuccessFlag } = subscriptionSlice.actions;

export const subscriptionSelector = (state) => state[namespace];

export default subscriptionSlice.reducer;
